<template>
  <div class="atb-flex atb-flex-row atb-flex-wrap atb-justify-center atb-pt-32">
    <Card class="card-size">
      <template #body>
        <div class="atb-items-center atb-text-center">
          <span class="header-font block">{{ $t('404') }}</span>
          <span class="text-font block">{{ $t('Oops') }}</span>
          <span class="text-font block">{{ $t('pageNotFound') }} </span>
        </div>
        <div
          class="atb-flex atb-flex-row atb-justify-center atb-gap-x-8 atb-pt-8"
        >
          <Button
            v-if="isLoggedin"
            @click="$router.push('/ams/home')"
          >
            {{ $t('backHome') }}</Button
          >
          <Button
            v-else
            @click="$router.push('/')"
          >
            {{ $t('login') }}</Button
          >
        </div>
      </template>
    </Card>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import Button from '@atb-ui/eds-vue/src/components/Button.vue';
  import Card from '@atb-ui/eds-vue/src/components/Card.vue';
  import { useAuthStore } from '@/app/shared/stores/auth-store';

  export default defineComponent({
    name: 'PageNotFound',
    components: {
      Button,
      Card,
    },
    computed: {
      isLoggedin() {
        const authstore = useAuthStore();
        return authstore.isAuthenticated;
      },
    },
  });
</script>

<style scoped>
  .card-size {
    width: 50%;
  }

  .header-font {
    font-size: 8rem;
    font-weight: 100;
  }

  .text-font {
    font-size: 1.2rem;
  }
  .eds-card-outline {
    width: 25%;
  }
</style>
